/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import RegistrationFormsIcon from 'icons/RegistrationFormsIcon';

const messages = defineMessages({
  title: {id: 'navigation.registration'},
});

const RegistrationItem = () => (
  <StudentRouteLinkItem
    iconBefore={RegistrationFormsIcon}
    route="midas/student/registration"
    title={messages.title}
  />
);

export default RegistrationItem;
